import {configureStore} from "@reduxjs/toolkit"
import graphReducer from "redux/graphSlice"
import loggingMiddleware from "redux/actionLog"

export default configureStore({
	reducer: {
		graph: graphReducer
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(loggingMiddleware)
})